module.exports = __webpack_public_path__ + "img/sale-manager.3b860399.png";